// Cartão "Custos e consumo" do Início (0.17.0): os caminhões em que o
// consumo caiu ou o custo por km subiu (contas em lib/avisos.js). Leva ao
// relatório dos caminhões dos últimos meses.
import { dadosDosRelatorios } from '../dados.js';
import { creditosDaViagem, regraValendo } from '../lib/acerto.js';
import { avisosDeCustoEConsumo, textoDoAvisoDeCusto } from '../lib/avisos.js';
import { h, icone } from '../lib/dom.js';
import { hojeDaEmpresa } from '../sessao.js';

export const linhaDoAvisoDeCusto = textoDoAvisoDeCusto;

function mesAntes(mes, n) {
  const [a, m] = mes.split('-').map(Number);
  return new Date(Date.UTC(a, m - 1 - n, 1)).toISOString().slice(0, 7);
}

export async function cartaoDosAvisos() {
  const hoje = hojeDaEmpresa();
  const avisos = avisosDeCustoEConsumo(await dadosDosRelatorios(), { hoje, regraValendo, creditosDaViagem });
  if (avisos.length === 0) return null;
  const mesAtual = hoje.slice(0, 7);
  const href = `#/relatorios/caminhoes?periodo=escolher&de=${mesAntes(mesAtual, 4)}&ate=${mesAtual}`;
  return h('a', { class: 'cartao a-custos', href },
    icone('grafico', { tamanho: 28 }),
    h('span', { class: 'cartao-corpo' },
      h('span', { class: 'cartao-titulo' }, 'Custos e consumo'),
      avisos.slice(0, 3).map((a) => h('span', { class: 'cartao-linha' }, linhaDoAvisoDeCusto(a))),
      avisos.length > 3 && h('span', { class: 'cartao-linha' }, `e mais ${avisos.length - 3}`)),
    icone('seta', { classe: 'icone seta' }));
}
